"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIcon = exports.StyledCircle = exports.StyledRadioButton = exports.StyledDescription = exports.StyledTitle = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const radio_group_types_1 = require("./radio-group.types");
exports.StyledTitle = theme_1.styled.div `
  ${theme_1.typography.medium18};
  ${theme_1.mixins.flex({ alignItems: 'center' })};
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledDescription = theme_1.styled.div `
  ${theme_1.typography.regular14};
  line-height: 20px;
  margin-top: 6px;
  color: ${({ theme }) => theme.colors.text.primary};
`;
exports.StyledRadioButton = theme_1.styled.label `
  ${theme_1.mixins.flex({
    alignItems: 'center',
    justifyContent: 'space-between',
    wrap: false,
})};
  padding: 16px;
  position: relative;
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)`; }};
  cursor: pointer;
  letter-spacing: 0.02em;
  user-select: none;

  ${({ checked, theme }) => !checked &&
    (0, theme_1.css) `
      &:hover {
        border-color: ${theme.colors.neutral[50]};
      }
    `}

  :not(:first-child) {
    margin-top: 8px;
  }

  input {
    display: none;
  }

  border: ${({ checked, theme }) => checked
    ? `2px solid ${theme.colors.surface.brand}`
    : `1px solid ${theme.colors.neutral[20]}`};
  transition: all 0.2s ease-out;
  box-sizing: border-box;
  height: auto;

  ${({ iconPosition }) => iconPosition === radio_group_types_1.IconPosition.Left &&
    (0, theme_1.css) `
      flex-direction: row-reverse;
      justify-content: flex-end;
    `}
`;
exports.StyledCircle = theme_1.styled.div `
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1.5px solid ${({ theme }) => theme.colors.neutral[50]};
  margin-left: 12px;

  ${({ selectedCurrentVal, theme }) => selectedCurrentVal &&
    (0, theme_1.css) `
      border-color: ${theme.colors.surface.brand};
    `}

  ${({ iconPosition }) => iconPosition === radio_group_types_1.IconPosition.Left &&
    (0, theme_1.css) `
      margin-left: 0;
    `}
`;
exports.StyledIcon = theme_1.styled.div `
  ${({ iconPosition }) => iconPosition === radio_group_types_1.IconPosition.Left &&
    (0, theme_1.css) `
      margin-right: 12px;
    `}
`;
